const dependencies = importAngularDependencies(
  require.context('./', true, /^(?!.*\.(spec|test)\.(js|ts)$).*\.(js|ts)$/),
  './realtime.common.js'
);

export default angular.module('doxy.realtime.common', dependencies).name;
